import OwnerService from 'aurora-composition/services/ownerService';
import PrimaryContactService from 'aurora-composition/services/PrimaryContactService';
import history from 'aurora-utils/history';
import * as types from './constants';

export const fetchBuyerDetails = (id, type) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFFPLAN_BUYER });

    let buyer = {};

    if (type === 'person') {
      buyer = await OwnerService.fetchUserById(id);
    }

    dispatch({ type: types.FETCH_OFFPLAN_BUYER_SUCCESS });
    return { buyer };
  } catch (error) {
    dispatch({ type: types.FETCH_OFFPLAN_BUYER_ERROR, payload: error });
    return error;
  }
};

export const fetchPrimaryContact = (searchFilter, owner, applicationId) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_PRIMARY_CONTACT });
    let res;
    let contacts = [];
    const pathname = history?.location?.pathname;
    const profileMode = pathname === '/app/user/primary-contact' && true;
    const { leaseReducer } = getState();
    const workflow = pathname.includes('amendment')
      ? 'amendment'
      : pathname.includes('registration')
      ? 'registration'
      : 'renewal';

    // applicationId
    const filterPayload = {
      page: +searchFilter?.page,
      size: searchFilter?.PAGE_SIZE,
    };

    if (profileMode) {
      res = await PrimaryContactService.getContacts(filterPayload);
      contacts = res?.primaryContactDTOList;
    } else {
      const payload = {
        applicationId:
          applicationId ||
          searchFilter?.applicationId ||
          leaseReducer?.[workflow]?.applicationId ||
          localStorage.getItem('localStorageApplicationId'),
        licenseNumber: owner?.licenseNumber || leaseReducer?.[workflow]?.form?.primaryLessorObj?.tradeLicenseNumber,
        emirateId: owner?.eidOrUnified || leaseReducer?.[workflow]?.form?.primaryLessorObj?.lessorId,
      };
      if (!owner?.eidNumber) {
        payload.unifiedNumber = owner?.unifiedNumber;
      }
      res = await PrimaryContactService.getApplicationContacts(payload);
      contacts = res?.result;
    }

    dispatch({
      type: types.FETCH_PRIMARY_CONTACT_SUCCESS,
      payload: {
        contacts,
      },
    });
    return res;
  } catch (error) {
    dispatch({ type: types.FETCH_PRIMARY_CONTACT_ERROR, payload: error });
    return error;
  }
};

export const addPrimaryContact = data => async (dispatch, getState) => {
  try {
    dispatch({ type: types.ADD_PRIMARY_CONTACT });
    const pathname = history?.location?.pathname;
    const profileMode = pathname === '/app/user/primary-contact' && true;
    const { leaseReducer } = getState();

    const workflow = pathname.includes('amendment')
      ? 'amendment'
      : pathname.includes('registration')
      ? 'registration'
      : 'renewal';
    let res = null;
    const form = leaseReducer?.[workflow]?.form;
    if (profileMode) {
      res = await PrimaryContactService.addContact(data);
    } else {
      res = await PrimaryContactService.addApplicationContact({
        ...data,
        applicationId: leaseReducer?.[workflow]?.applicationId,
        licenseNumber: form?.primaryLessorObj?.licenseNumber || form?.primaryLessorObj?.tradeLicenseNumber,
        emirateId: form?.primaryLessorObj?.eidOrUnified || form?.primaryLessorObj?.lessorId,
        unifiedNumber: form?.primaryLessorObj?.unifiedNumber,
      });
    }

    res && dispatch({ type: types.ADD_PRIMARY_CONTACT_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: types.ADD_PRIMARY_CONTACT_ERROR, payload: error });
    return error;
  }
};

export const removePrimaryContact = id => async dispatch => {
  try {
    dispatch({ type: types.REMOVE_PRIMARY_CONTACT });

    const res = await PrimaryContactService.removeContact(id);

    dispatch({ type: types.REMOVE_PRIMARY_CONTACT_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: types.REMOVE_PRIMARY_CONTACT_ERROR, payload: error });
    return error;
  }
};
